import React, { useState, useRef, useEffect } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import fetchCustom from '../../wp_helpers/fetchCustom';
import EventHandler from './EventHandler'
import Button from '@components/legacy/core/Button'
import Icon from '../core/Icon';
// import { useTranslations } from '../context/TranslationContext';


const AiAlpacaForm = ({ assistantDataJson }) => {
  const assistantId = assistantDataJson.id;
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) {
      return;
    }
    const $root = $(root);
    const $render = $root.find(`#${assistantId}_form_render`);
    const formHandler = new alpacaForm();
    // Pass a common ancestor of .form_json and the render div so alpacaForm finds the hidden
    // field without relying on closest('form') (avoids empty <form> workarounds outside React).
    formHandler.init($root, $render);
    formHandler.updateJsonConfiguration(JSON.parse(assistantDataJson.json_form));

    return () => {
      const el = rootRef.current;
      if (!el) {
        return;
      }
      const $renderedForm = $(el).find(`#${assistantId}_form_render`);
      if ($renderedForm.length && $renderedForm.alpaca('exists')) {
        $renderedForm.alpaca('destroy');
      }
    };
  }, []);

  return (
    <div ref={rootRef} className="ai-alpaca-form-root">
      <input className="form_json" id={assistantId + "_form_json"} name={assistantId + "_form_json"} hidden />
      <div className="form-placeholder" id={assistantId + "_form_render"}></div>
      <div className="form-json-schema" style={{ display: "none" }}></div>
    </div>
  );
};
const AiServiceTask = ({assistantData, assistantLayout, targetButton, Assistants, notify, disabled}) => {
//   const { t } = useTranslations();
  const alpacaFormRef = useRef();
  const [showAiAssistant, setAiAssistantState] = useState(false)
  const [webSocketUrl, setWebSocketUrl] = useState(null);
  const [passKey, setPassKey] = useState(null);
  const [closeURL, setCloseURL] = useState(null);
  const [isWebSocketOpen, setIsWebSocketOpen] = useState(false);
  const assistantDataJson = typeof assistantData === 'string' ? JSON.parse(assistantData) : (assistantData || {});
  const additionalInfo = {
    rendering: assistantDataJson.rendering
  }
  const assistantId = assistantDataJson.id;
  const context = assistantDataJson.context;

  const handleMessage = async (event) => {
    var ws_msg = event.data;
    if (ws_msg instanceof Blob) {
      // Binary message
      ws_msg = await binaryToText(event.data)
    }
    const message = JSON.parse(ws_msg);
    const cb = async () => {
      await postGenerate()
    }

    if (message) {
      if (message.error && typeof message.error === "string") {
        notify(message.error);
        return;
      }

      const selector = Object.keys(message)[0]; // Assuming only one key
      const data = message[selector];
      const assistant = Assistants[assistantId]['selectors'][selector]
      EventHandler.handleEvent({ selector, data, assistantId, cb, additionalInfo }, assistant);
    }

  };

  const binaryToText = async (blob) => {
    try {
      return await blob.text()
    } catch (error) {
      console.error('Error converting Blob to text:', error);
    }
  }


  const { sendJsonMessage, readyState } = useWebSocket(webSocketUrl,
    {
      onMessage: handleMessage,
      shouldReconnect: () => false,
      onOpen: () => {
        EventHandler.resetSelectorsReceived(assistantId);
        sendJsonMessage({ "passkey": passKey })
      }
    }
  );

  useEffect(() => {
    setIsWebSocketOpen(readyState === ReadyState.OPEN);
  }, [webSocketUrl, readyState]);

  useEffect(() => {
    if (targetButton) {
      $(`#${assistantId}_ai_buttons`).appendTo(`#${targetButton}`);
    }

    return () => {
      if (webSocketUrl)
        closeChannel()
    };
  }, []);


  const dropdownRef = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !event.target.closest('.btn-ai')) {
        setAiAssistantState(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const onGenerateClick = () => {
    if (assistantDataJson.json_form) {
      setAiAssistantState(!showAiAssistant)
    } else {
      preGenerate();
    }


  }

  const preGenerate = () => {
    const preGenerateFunc = Assistants[assistantId]?.preGenerateFunc
    if (typeof preGenerateFunc == 'function') {
      preGenerateFunc(createChannel)
    } else {
      createChannel()
    }
  }

  const postGenerate = () => {
    const postGenerateFunc = Assistants[assistantId]?.postGenerateFunc
    if (typeof postGenerateFunc == 'function') {
      postGenerateFunc(closeChannel)
    } else {
      closeChannel()
    }
  }

  const createChannel = async () => {
    try {

      const selectorsKey = Object.keys(Assistants[assistantId]['selectors']);
      const firstSelectorKey = { 'field': selectorsKey.length > 1 ? selectorsKey : selectorsKey[0] };
      const formFields = JSON.parse($(`#${assistantId}_form_json`).val() || '{}');

      const additionalParams = Assistants[assistantId]?.getAdditionalParams?.() ?? {};

      const data = { ...formFields, ...firstSelectorKey, ...context, ...additionalParams };

      const response = await fetchCustom(assistantDataJson.create_assistant_session, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      if (response.ok) {
          const { ws_url, pass, close_url } = responseData;
          setAiAssistantState(false)
          setWebSocketUrl(ws_url)
          setPassKey(pass)
          setCloseURL(close_url)
          Assistants[assistantId]?.onSessionCreated?.(responseData, notify)
      } else {
        const { error } = responseData;
        if (error) {
          if (Assistants[assistantId]?.errorCallback) {
            Assistants[assistantId].errorCallback(responseData, notify)
          } else {
            notify(error)
          }
        }

        setAiAssistantState(false)
      }
    } catch (error) {
      setAiAssistantState(false)
      console.error('Error submitting form:', error);
    }
  }

  const closeChannel = async () => {
    try {
      Assistants[assistantId]?.cancelCallback?.();
      const response = await fetchCustom(closeURL, {
        method: 'DELETE',
        body: null,
      });

      if (response.ok) {
        const responseData = await response.json();
        setWebSocketUrl(null)
      } else {
        setAiAssistantState(false)
        console.error('Failed to submit form.');
      }
    } catch (error) {
      setAiAssistantState(false)
      console.error('Error submitting form:', error);
    }
  }



  const generate = () => {
    var $form = $(`#${assistantId}_form_render`)
    $form.alpaca('get').refreshValidationState(true, () => {
      const notValid = $form.alpaca('get').field.hasClass('alpaca-invalid');
      if (notValid) {
        return
      }
      // Focus out and click triggers at the same time, to sync these events added this timeout
      setTimeout(() => {
        preGenerate()
      }, 200)
    })
  }

  const AiButtonRender = (title, onClick, className, hasDropdown) => {
    return <Button type='ai' title={title} onClick={onClick} className={className} hasDropdown={hasDropdown} />
  }

  return (
    <div id={`${assistantId}_ai_buttons`} className="text-right">
      <div className="ai-button-wrapper">
        {Assistants[assistantId]?.button ? (
          !isWebSocketOpen ? 
            Assistants[assistantId].button(assistantDataJson.button_title, onGenerateClick, '', { hasDropdown: !!assistantDataJson.json_form, disabled }) :
            Assistants[assistantId].button(global_i18n('cancel_i18n'), closeChannel, 'btn-loading', { hasDropdown: !!assistantDataJson.json_form, disabled: false })
        ) : (
          !isWebSocketOpen ?
            AiButtonRender(assistantDataJson.button_title, onGenerateClick, '', !!assistantDataJson.json_form) :
            AiButtonRender(global_i18n('cancel_i18n'), closeChannel, 'btn-loading', !!assistantDataJson.json_form)
        )}
        {assistantDataJson.json_form && showAiAssistant &&
          <div className='ai-assitant-dropdown-wrapper' ref={dropdownRef}>
            <div className="dropdown-ai dropdown-menu dropdown-menu-right show">
              <div className='alpaca_form_wrapper'>
                <AiAlpacaForm assistantDataJson={assistantDataJson} />
              </div>
              <div className="text-right">
                <Button type="link" className="btn-ai generate-btn" onClick={generate}>
                  <span className="icon-svg-send-03" data-css-prop="mask-image"></span>
                </Button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default AiServiceTask;